import * as auth from './auth'
import * as promotions from './promotions'
import * as campaigns from './campaigns'
import * as snackbar from './snackbar'
import * as companies from './companies'
import * as users from './users'
import * as topics from './topics'
import * as categories from './categories'
import * as images from './images'
import * as statistics from './statistics'
import * as variants from './variants';
import * as overlay from './overlay';

import * as campaignsSettings from './settings/campaigns'
import * as userSettings from './settings/user'
import * as sideBarWidgetsSettings from './settings/sidebar-widgets';

export const api = {
	auth: auth,
	promotions: promotions,
	campaigns: campaigns,
	snackbar: snackbar,
	companies: companies,
	users: users,
	topics: topics,
	categories: categories,
	images: images,
	statistics: statistics,
	variants: variants,
	overlay: overlay,
	settings: {
		campaigns: campaignsSettings,
		user: userSettings,
		sidebarWidgets: sideBarWidgetsSettings,
	},
};


// WEBPACK FOOTER //
// ./src/api/index.js